/**
 * Maps simplified placement names to floating-ui placement format
 * Converts rc-tooltip/antd style placements to floating-ui format
 */
export const PLACEMENT_MAP = {
    top: 'top',
    topLeft: 'top-start',
    topRight: 'top-end',
    bottom: 'bottom',
    bottomLeft: 'bottom-start',
    bottomRight: 'bottom-end',
    left: 'left',
    leftTop: 'left-start',
    leftBottom: 'left-end',
    right: 'right',
    rightTop: 'right-start',
    rightBottom: 'right-end',
};

/**
 * Converts a placement string to floating-ui format
 * @param {string} placement - The placement string (rc-tooltip or floating-ui format)
 * @returns {string} - The floating-ui formatted placement
 */
export const normalizeFloatingPlacement = (placement) => {
    return PLACEMENT_MAP[placement] || placement;
};
